import { Card, Elevation } from "@blueprintjs/core";
import * as React from "react";
import styled from "styled-components";
import { DrupalClubDto } from "../../api";
import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales";
import { generateAddress } from "../../utils";

export interface IDrupalClubCardProps {
  clubInformation: DrupalClubDto;
}

const Title = styled.p`
  font-size: 28px;
`;

const SubTitle = styled.p`
  font-weight: bold;
  font-size: 18px;
`;

const Spacing = styled.div`
  margin: 0.5rem;
`;

export const DrupalClubCard: React.FunctionComponent<IDrupalClubCardProps> = ({ clubInformation }) => {
  const { t } = useTl();

  React.useEffect(() => {
    console.log("CLUB INFO", clubInformation);
  }, [clubInformation]);

  return (
    <Card elevation={Elevation.FOUR} style={{ margin: "1rem" }}>
      <Title>{clubInformation.name}</Title>
      <p>
        {t(ETLCodes.Email)}: <a href={"mailto:" + clubInformation.email}>{clubInformation.email}</a>
      </p>
      <p>
        {t(ETLCodes.Website)}: <a href={clubInformation.website}>{clubInformation.website}</a>
      </p>
      {clubInformation?.chairmans && clubInformation?.chairmans?.length >= 0 ? (
        clubInformation?.chairmans?.map((chair) => (
          <>
            <Spacing />
            <SubTitle>{t(ETLCodes.Chairman)}</SubTitle>
            <p>{chair.computedName}</p>
            <p>{generateAddress(chair.number, chair.street, chair.city, chair.postalCode, chair.countryIso)}</p>
            <p>
              {t(ETLCodes.PhoneNumber)}:{chair.phoneNumber ?? chair.mobilePhoneNumber}
            </p>
          </>
        ))
      ) : (
        <>{t(ETLCodes.NoInformation)}</>
      )}

      {clubInformation?.secretaries && clubInformation?.secretaries?.length >= 0 ? (
        clubInformation?.secretaries?.map((secretary) => (
          <>
            <Spacing />
            <SubTitle>{t(ETLCodes.Secretary)}</SubTitle>
            <p>{secretary.computedName}</p>
            <p>
              {generateAddress(
                secretary.number,
                secretary.street,
                secretary.city,
                secretary.postalCode,
                secretary.countryIso
              )}
            </p>
            <p>
              {t(ETLCodes.PhoneNumber)}:{secretary.phoneNumber ?? secretary.mobilePhoneNumber}
            </p>
          </>
        ))
      ) : (
        <>{t(ETLCodes.NoInformation)}</>
      )}
    </Card>
  );
};
